import { en, es, pt } from '@/locales'
import * as ls from '@/services/localStorage'
import type { App } from 'vue'
import { createI18n } from 'vue-i18n'

type MessageSchema = typeof pt & typeof en & typeof es

export const i18n = createI18n<[MessageSchema], 'pt' | 'en' | 'es'>({
  locale: ls.get(process.env.VUE_APP_LS_LANGUAGE_KEY || 'VUE_APP_LS_LANGUAGE_KEY') || 'pt',
  fallbackLocale: 'pt',
  messages: { pt: pt as MessageSchema, en: en as MessageSchema, es: es as MessageSchema },
  globalInjection: true,
  legacy: false,
})

export function registerVueI18n(app: App) {
  app.use(i18n)
}
